export default {
  NA: 'NA',
  Always:'Always',
  When:'When'   
}